goog.provide('el8.ptdata.model.note.baseBullet');

goog.require('el8.model.base');


// -------------------
// ** BASE NOTE BULLET **
// Needs to be global to be accessible
// to both visit note and nonvisite note 
// constructors
// -------------------
el8.ptdata.model.note.baseBullet = function(spec) {
    spec = spec || {};
    this.populate(spec);
};
el8.ptdata.model.note.baseBullet.inheritsFrom(el8_Entity);

el8.ptdata.model.note.baseBullet.addIntProperty("noteId", true);
el8.ptdata.model.note.baseBullet.addIntProperty("parentId", true);
el8.ptdata.model.note.baseBullet.addIntProperty("sequence", true);
el8.ptdata.model.note.baseBullet.addStringProperty("text", true);
el8.ptdata.model.note.baseBullet.addBoolean("textSafe", false, false);
el8.ptdata.model.note.baseBullet.addProperty("textFormatting");

// Today, the baseBullet instance will either have a documentId
// or a patientItemId or a handoutId -- just one or them
el8.ptdata.model.note.baseBullet.addIntProperty("documentId", true);
el8.ptdata.model.note.baseBullet.addIntProperty("labResultId", true);
el8.ptdata.model.note.baseBullet.addIntProperty("patientItemId", true);
// This property currently only exists in visit notes, but in the future
// we anticipate nonvisit notes supporting it as well
el8.ptdata.model.note.baseBullet.addIntProperty("handoutId", true);

// These properties are maintained by the server for version
// control and concurrency. I think no need for the client
// to set them.
el8.ptdata.model.note.baseBullet.addIntProperty("authorId", true);
el8.ptdata.model.note.baseBullet.addProperty("updated", true);
el8.ptdata.model.note.baseBullet.addIntProperty("version", true);

// may have other baseBullets as children
el8.ptdata.model.note.baseBullet.addProperty('childrenSet');

el8.ptdata.model.note.baseBullet.prototype.getRefId = function() {
    return this.getLabResultId() || this.getDocumentId() || this.getPatientItemId() || this.getHandoutId();
};

el8.ptdata.model.note.baseBullet.prototype.asMap = function() {
    var mapped = el8_Entity.prototype.asMap.apply(this, [true, false]);
    mapped['text_formatting'] = null;
    return mapped;
};



